// constants
import { SELECTORS } from '@/scripts/constants';

// component
import Component from '@/components/Component';

// assets
import './sliders.scss';

class SwiperSlider extends Component {
  constructor(props) {
    super(props);

    const swiperConfig = {
      slidesPerView: 3,
      spaceBetween: 20,
      keyboard: {
        onlyInViewport: true,
      },
      navigation: {
        nextEl: '[data-role="swiper-button-next"]',
        prevEl: '[data-role="swiper-button-prev"]',
      },
      speed: 700,
    };

    this.setProps({
      swiperConfig,
    });

    this.swiper = null;
  }

  init() {
    this.swiper = new Swiper(this._element, this._props.swiperConfig);
  }
}

export class NewsSlider extends SwiperSlider {
  constructor(props) {
    super(props);
    this.setProps({
      swiperConfig: {
        ...this._props.swiperConfig,
        spaceBetween: 25,
        scrollbar: {
          el: this._element.querySelector('.swiper-scrollbar'),
          draggable: true,
          dragSize: 30,
        },
        breakpoints: {
          1023: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          639: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
    });
  }
}

export class FadeSlider extends SwiperSlider {
  constructor(props) {
    super(props);
    this.setProps({
      swiperConfig: {
        ...this._props.swiperConfig,
        spaceBetween: 0,
        speed: 0,
        effect: 'fade',
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        fadeEffect: {
          crossFade: true,
        },
        scrollbar: {
          el: this._element.querySelector('.swiper-scrollbar'),
          draggable: true,
          dragSize: 30,
        },
      },
    });
  }
}


export class CoverflowSlider extends SwiperSlider {
  constructor(props) {
    super(props);
    this.setProps({
      swiperConfig: {
        ...this._props.swiperConfig,
        // loop: true,
        spaceBetween: 0,
        simulateTouch: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        // loopedSlides: 3,
        navigation: {
          nextEl: '[data-role="swiper-button-next"]',
          prevEl: '[data-role="swiper-button-prev"]',
        },
        effect: 'coverflow',
        // initialSlide: 1,
        coverflowEffect: {
          slideShadows: false,
          depth: 600,
        },
        slidesPerView: 1,
      },
    });
  }

  _updateView() {
    const slides = this.swiper ? Array.from(this.swiper.slides) : [];
    const { activeIndex = 0 } = this._state;
    slides.forEach((slide, i) => {
      slide.classList.toggle(SELECTORS.hidden, Math.abs(activeIndex - i) > 1);
    });
  }

  init() {
    super.init();
    this.swiper.on('slideChange', () => {
      const { activeIndex } = this.swiper;
      this._setState({ activeIndex });
    });

    this.swiper.slideTo(1, 0);
    // https://github.com/nolimits4web/Swiper/issues/2099

    // const nextEl = this.swiper.el.querySelector('[data-role="custom-swiper-next"]');
    // const prevEl = this.swiper.el.querySelector('[data-role="custom-swiper-prev"]');
    // nextEl.addEventListener('click', () => {
    //   this.swiper.slideNext();
    // });
    // prevEl.addEventListener('click', () => {
    //   this.swiper.slidePrev();
    // });
  }
}
